import React, { useState } from 'react';
import axios from 'axios';

function App() {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleGenerateReport = async () => {
        setLoading(true);
        setMessage('');
        try {
            const response = await axios.get('http://198.139.13.115:3015/generate-report', {
                params: { startDate, endDate },
                responseType: 'blob',
            });

            if (response.status === 200) {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.download = 'daily_report.html';
                link.click();
                setMessage('Reporte generado correctamente');
            } else {
                setMessage('Error al generar el reporte');
            }
        } catch (error) {
            setMessage('Error al generar o enviar el reporte');
        }
        setLoading(false);
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Generar Reporte de Ventas</h1>

            <label>
                Fecha de inicio:
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{ marginBottom: '10px', marginLeft: '10px', padding: '5px' }}
                />
            </label>
            <br />
            <label>
                Fecha de fin:
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{ marginBottom: '20px', marginLeft: '10px', padding: '5px' }}
                />
            </label>
            <br />

            <button onClick={handleGenerateReport} disabled={loading || !startDate || !endDate}>
                {loading ? 'Generando...' : 'Generar y Enviar Reporte'}
            </button>

            {message && <p>{message}</p>}
        </div>
    );
}

export default App;
